import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import Switch from "react-switch";
import moment from "jalali-moment";
import { baseURL } from "../../constants/pathnames";
import Body from "../Home/Body";
import Input from "../Input/Input";
import Table from "../Table/Table";
import Steps from "./Steps";
import Button from "../Button/Button";
import ModalConfirm from "./ModalConfirm";

const AdDetail = () => {
  const { token } = useSelector((state) => state.users);
  const history = useHistory();
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);

  const { id } = useParams();
  const [isModalConfirm, setIsModalConfirm] = useState(false);
  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const columns = [
    { Header: "عنوان", accessor: "title" },
    { Header: "نام و نام خانوادگی", accessor: "name" },
    { Header: "کد آگهی", accessor: "code" },
    { Header: "تاریخ", accessor: "date" },
    { Header: "وضعیت", accessor: "status" },
  ];
  const [deactive, setDeactive] = useState(false);
  const [deactivedescription, setDeactiveDescription] = useState("");
  const [descriptionBox, setDescriptionBox] = useState(false);
  const [deactivedescriptionError, setDeactiveDescriptionError] = useState("");
  const [StepsData, setStepsData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [btntitle, setBtntitle] = useState("ثبت");

  const getData = useCallback(() => {
    axios
      .get(`${baseURL}product/panel/update/${id}/`, header)
      .then((res) => {
        setDeactive(res.data?.is_active);
        setData(res.data);
        setRows([
          {
            title: res.data?.name,
            name: res.data?.user,
            code: res.data?.id,
            date: moment(res.data?.created_time)
              .locale("fa")
              .format("YYYY/MM/DD"),
            status: res.data?.is_active ? (
              <div className="color-green2">فعال</div>
            ) : (
              <div className="color-red">غیرفعال</div>
            ),
          },
        ]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id, header]);
  useEffect(() => {
    getData();
  }, [getData]);

  const handleConfirm = useCallback(() => {
    if (deactivedescription === "" && !deactive)
      setDeactiveDescriptionError("توضیحات را وارد کنید");
    else {
      setLoader(true);
      const data = {
        ...StepsData,
        is_active: deactive,
      };
      if (data["reasons"].length === 0) delete data["reasons"];
      if (!deactive) data["description"] = deactivedescription;

      axios
        .patch(`${baseURL}product/panel/update/${id}/`, data, header)
        .then((res) => {
          setLoader(false);
          setBtntitle("تغییرات ثبت شد");
          getData();
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
        });
    }
  }, [header, StepsData, deactive, deactivedescription, getData, id]);

  return (
    <>
      <Body state={2}>
        <div className="overflow-y-auto overflow-x-hidden">
          <>
            <div className="flex justify-between items-center gap-3 h-16 mb-10">
              <div className="flex justify-start items-center font-semibold gap-4 py-4">
                <img
                  className="cursor-pointer"
                  src="/statics/images/arrow-right-black1.svg"
                  width="16px"
                  height="16px"
                  alt="arrow"
                  onClick={() => {
                    history.goBack();
                  }}
                />
                <span>جزئیات کالا</span>
              </div>

              <div className="m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8">
                <img
                  className="mx-auto "
                  src="/statics/images/bell.svg"
                  width="16"
                  height="16"
                  alt="bell"
                />
              </div>
            </div>

            <div className="p-3 rounded-lg shadow m-1">
              <div className="md:shadow md:rounded-xl my-5 md:border">
                <Table
                  classs="paneltable UserDetailTable"
                  columns={columns}
                  data={rows}
                />
              </div>

              {data?.reports?.length > 0 && (
                <div className=" p-3">
                  <span className="color-blue my-3">گزارش آگهی</span>
                  <ul className="color-red list-inside list-disc py-4 leading-7">
                    {data?.reports?.map((row) => (
                      <li className="color-red text-xs my-3" key={row?.id}>
                        <span className="text-red-600 text-sm my-auto ">
                          این آگهی در تاریخ{" "}
                          {moment(row?.created_time)
                            .locale("fa")
                            .format("YYYY/MM/DD")}{" "}
                          توسط {row?.user}{" "}
                          {row?.title ? " به دلیل " + row?.title : ""} گزارش شده
                          است.
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <Steps data={data} setStepsData={setStepsData} />
            </div>
            <div className="flex flex-col justify-end items-center max-w-xs mr-auto shadow rounded-xl my-5 mx-1 gap-4 p-3">
              <Switch
                offColor="#ccd6e8"
                onColor="#4a659c"
                onHandleColor="#fff"
                offHandleColor="#fff"
                activeBoxShadow="0"
                handleDiameter={10}
                height={14}
                width={40}
                uncheckedIcon={
                  <div className="flex justify-center items-center h-full font-8 pr-2 color-blue">
                    غیرفعال
                  </div>
                }
                checkedIcon={
                  <div className="flex justify-center items-center h-full font-8 pl-2 text-white">
                    فعال
                  </div>
                }
                onChange={(change) => {
                  setDeactive(change);
                  setDescriptionBox(true);
                }}
                checked={deactive}
              />

              {!deactive && descriptionBox && (
                <div>
                  <span className="text-xs">
                    درصورت غیر فعال کردن این کالا دلیل آن را ذکر کنید
                  </span>
                  <Input
                    placeholder="توضیحات"
                    maxWidth="100%"
                    value={deactivedescription}
                    error={deactivedescriptionError}
                    type="text"
                    textarea
                    margin="0"
                    onChange={(event) => {
                      setDeactiveDescription(event.target.value);
                      setDeactiveDescriptionError("");
                    }}
                  />
                </div>
              )}

              <Button
                title={btntitle}
                margin="0 8px"
                fontSize="12px"
                maxWidth="150px"
                maxHeight="36px"
                onClick={() => {
                  setIsModalConfirm(true);
                }}
                loading={loader}
              />
            </div>
          </>
        </div>
      </Body>

      {isModalConfirm && (
        <ModalConfirm
          deactive={deactive}
          onCancel={() => setIsModalConfirm(!isModalConfirm)}
          product_status={StepsData?.product_status}
          confirm={() => handleConfirm()}
        />
      )}
    </>
  );
};

export default AdDetail;
